module.exports = __webpack_public_path__ + "static/media/img_21.9646a3ac.JPG";